import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-page fade-in">
      <div className="about-container">
        <div className="about-header">
          <h1>About BeanBuzz</h1>
          <p className="about-subtitle">Revolutionizing Cafe Management</p>
        </div>

        <div className="about-content">
          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              BeanBuzz is a comprehensive cafe management system designed to streamline operations, 
              enhance customer experience, and boost profitability for cafe owners and managers.
            </p>
          </div>

          <div className="about-section">
            <h2>System Status</h2>
            <div className="status-card">
              <div className="status-indicator development"></div>
              <div className="status-content">
                <h3>🚧 Currently in Development</h3>
                <p>
                  BeanBuzz is actively being developed and refined. We're working hard to create 
                  the most intuitive and powerful cafe management solution available.
                </p>
                <ul className="development-features">
                  <li>✅ Core cafe management features</li>
                  <li>✅ QR code ordering system</li>
                  <li>✅ Real-time kitchen dashboard</li>
                  <li>✅ Menu management tools</li>
                  <li>🔄 Advanced analytics (coming soon)</li>
                  <li>🔄 Multi-location support (coming soon)</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Key Features</h2>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">📱</div>
                <h3>Mobile-First Design</h3>
                <p>Optimized for tablets and smartphones, perfect for busy cafe environments.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">🍽️</div>
                <h3>QR Code Ordering</h3>
                <p>Customers can order directly from their table using QR codes.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">👨‍🍳</div>
                <h3>Kitchen Dashboard</h3>
                <p>Real-time order tracking and management for kitchen staff.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📋</div>
                <h3>Menu Management</h3>
                <p>Easy-to-use interface for updating menu items, prices, and availability.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">📊</div>
                <h3>Analytics</h3>
                <p>Track sales, popular items, and customer preferences.</p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">⚙️</div>
                <h3>Customizable</h3>
                <p>Personalize your cafe branding, themes, and feature settings.</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Get Involved</h2>
            <div className="cta-card">
              <h3>Interested in BeanBuzz?</h3>
              <p>
                We're looking for cafe owners and managers who want to be part of our development 
                journey. If you're interested in testing our system or learning more about our 
                cafe management solution, we'd love to hear from you.
              </p>
              <div className="cta-actions">
                <a href="mailto:vadym@suprun.ca" className="btn btn-primary">
                  Contact Us
                </a>
                <Link to="/beanbuzz-demo/dashboard" className="btn btn-secondary">
                  Try Demo
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="about-footer">
          <Link to="/" className="back-link">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 